import React, { useEffect } from 'react'
import { ToggleGroup, Toggle, H4, Separator } from '@fs/zion-ui'
import { useQueryParams } from '@fs/zion-router'
import { usePermissionsContext } from '../../providers'
import { useOnce } from '../../hooks'

const PermissionsGroup = ({ paramKey, isOpen }) => {
  const { query, setQuery, removeQuery } = useQueryParams()
  const { permissions, updatePermission } = usePermissionsContext()
  const handleChange = ({ target: { name, checked } }) => {
    updatePermission(name, checked)
    let existingPermissions = query?.[paramKey]?.split?.('|') || []
    if (checked) {
      existingPermissions.push(name)
    } else {
      existingPermissions = existingPermissions.filter((p) => p !== name)
    }
    if (existingPermissions.length) {
      setQuery({ [paramKey]: existingPermissions.join('|') })
    } else {
      removeQuery(paramKey)
    }
  }

  const onOnce = useOnce()
  useEffect(() => {
    if (isOpen) {
      onOnce(() => {
        const existingPermissions = query?.[paramKey]?.split?.('|') || []
        existingPermissions.forEach((p) => updatePermission(p, true))
      })
    }
  }, [isOpen, onOnce, paramKey, query, updatePermission])

  return (
    <>
      <H4 size="H5">Permissions</H4>
      <Separator size="nano" />
      <ToggleGroup>
        <Toggle
          label="Speaker"
          name="hasSpeakerAccess"
          checked={permissions.hasSpeakerAccess}
          onChange={handleChange}
        />
        <Toggle
          label="Exhibitor"
          name="hasExhibitorAccess"
          checked={permissions.hasExhibitorAccess}
          onChange={handleChange}
        />
        <Toggle
          label="Sponsor"
          name="hasSponsorAccess"
          checked={permissions.hasSponsorAccess}
          onChange={handleChange}
        />
        <Toggle
          label="Homeland"
          name="hasHomelandAccess"
          checked={permissions.hasHomelandAccess}
          onChange={handleChange}
        />
        <Toggle
          label="Content Admin"
          name="hasContentAdminAccess"
          checked={permissions.hasContentAdminAccess}
          onChange={handleChange}
        />
        <Toggle
          label="Super Admin"
          name="hasSuperAdminAccess"
          checked={permissions.hasSuperAdminAccess}
          onChange={handleChange}
        />
      </ToggleGroup>
    </>
  )
}

export default PermissionsGroup
